import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const OPTION_KEYS = ["ops", "lap_belt", "swivel_180", "swivel_360", "horizontal", "doc_holder", "backrest_ext", "heating"];
export const SWIVEL = ["swivel_180", "swivel_360"];

export const OPTION_LT = {
  ops: "OPS – operatoriaus pozicijos daviklis", lap_belt: "Juosmens diržas", swivel_180: "Sukimo mechanizmas 180°",
  swivel_360: "Sukimo mechanizmas 360°", horizontal: "Horizontali amortizacija", doc_holder: "Dokumentų dėklas", backrest_ext: "Atlošo prailginimas", heating: "Sėdynės šildymas",
};

export const toggleOption = (sel, key) => {
  if (sel.includes(key)) return sel.filter((k) => k !== key);
  const base = SWIVEL.includes(key) ? sel.filter((k) => !SWIVEL.includes(k)) : sel;
  return [...base, key];
};

export function useOptionDefs() {
  const [defs, setDefs] = useState({});
  const load = () => api.get("/option-defs").then((r) => setDefs(Object.fromEntries(r.data.map((d) => [d.key, d]))));
  useEffect(() => { load(); }, []);
  return [defs, load];
}
